import { useCancelarEscopoMacroDialog } from "./use-cancelar-escopo-macro-dialog";
import { CancelarEscopoMacroDialogView } from "./view-cancelar-escopo-macro-dialog";
import type { CancelarEscopoMacroDialogProps } from "./types-cancelar-escopo-macro-dialog";

export function CancelarEscopoMacroDialog(props: CancelarEscopoMacroDialogProps) {
  const vm = useCancelarEscopoMacroDialog(props);

  return <CancelarEscopoMacroDialogView {...vm} />;
}

export type * from "./types-cancelar-escopo-macro-dialog";
